<template>
  <!-- Header -->
  <header class="header-area header-three">
    <!-- Top Header -->
    <!-- <div class="header-top second-header d-none d-md-block">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-8 col-md-9 d-none d-md-block">
            <div class="header-cta">
              <ul>
                <li>
                  <div class="call-box">
                    <div class="icon">
                      <i class="fa-regular fa-phone"></i>
                    </div>
                    <div class="text">
                      <strong
                        ><a href="tel:+17802005410"
                          >+1 (780) 200-5410</a
                        ></strong
                      >
                    </div>
                  </div>
                </li>
                <li>
                  <div class="call-box">
                    <div class="icon">
                      <i class="fa-regular fa-envelope"></i>
                    </div>
                    <div class="text">
                      <strong
                        ><a href="info@archvarsity.com"
                          >info@archvarsity.com</a
                        ></strong
                      >
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-4 col-md-3 text-right d-none d-md-block">
            <div class="header-social">
              <span>
                <a href="#" title="Facebook"
                  ><i class="fab fa-facebook-f"></i
                ></a>
                <a href="#" title="Instagram"
                  ><i class="fab fa-instagram"></i
                ></a>
                <a href="#" title="Twitter"><i class="fab fa-twitter"></i></a>
                <a href="#" title="YouTube"><i class="fab fa-youtube"></i></a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Main Header -->
    <div id="header-sticky" class="menu-area">
      <div class="container">
        <div class="second-menu">
          <div class="row align-items-center">
            <div class="col-xl-3 col-lg-2 col-6">
              <div class="logo text-left">
                <router-link to="/">
                  <img
                    src="../assets/logo.png"
                    alt="logo"
                    style="padding: 10px"
                  />
                </router-link>
              </div>
            </div>
            <div class="col-xl-6 col-lg-7 d-none d-lg-block">
              <div class="main-menu text-center">
                <nav id="mobile-menu">
                  <ul>
                    <li>
                      <router-link
                        to="/"
                        @click.prevent="handleScrollToSection('home')"
                        >Home</router-link
                      >
                    </li>
                    <li>
                      <a href="/allcourses">Courses</a>
                      <ul class="submenu">
                        <li><router-link to="/courses">Courses</router-link></li>
                        <li><router-link to="/programs">Programs</router-link></li>
                        <li><router-link to="/trainings">Trainings</router-link></li>
                      </ul>
                    </li>
                    <!-- <li>
                      <router-link to="/courses">Courses</router-link>
                    </li> -->
                    <li>
                      <router-link to="/for-mentors">For Mentors</router-link>
                    </li>
                    <li><router-link to="/contact">Contact</router-link></li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-6 text-right">
              <div class="login mt-25 mb-25 d-none d-lg-block">
                <ul class="header-actions" style="display: flex; align-items: center; gap: 15px;">
                  <!-- Cart Icon/Button -->
                  <li v-if="isLoggedIn && accountType === 'student'">
                    <router-link to="/course-cart" class="cart-icon" style="position: relative;">
                      <i class="fas fa-shopping-cart" style="font-size: 20px;"></i>
                      <span class="cart-count" v-if="cartItemsCount > 0" 
                        style="position: absolute; top: -8px; right: -8px; background: red; color: white; border-radius: 50%; width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; font-size: 12px;">
                        {{ cartItemsCount }}
                      </span>
                    </router-link>
                  </li>
                  
                  <!-- Login/Signup or Dashboard -->
                  <li style="margin-right: 0; padding-right: 0">
                    <div class="second-header-btn" v-if="!isLoggedIn" style="display: flex; gap: 10px;">
                      <router-link to="/login" class="btn btn-outline" style="background-color: #2C5C9E;">Login</router-link>
                      <router-link to="/signup" class="btn btn-primary" style="background-color: #2C5C9E;">Sign Up</router-link>
                    </div>
                    <div class="second-header-btn" style="display: flex; align-items: center; gap: 5px; white-space: nowrap;" v-else>
                      <router-link :to="redirectUrl" class="btn" style="background-color: #2C5C9E;">
                        <i class="fas fa-user-circle" style="margin-right: 5px;"></i>
                        {{ redirectText }}
                      </router-link>
                      <button @click="handleLogout" class="btn" style="margin-left: 5px;background-color: #2C5C9E;">Logout</button>
                    </div>
                  </li>
                </ul>
              </div>
              <!-- Mobile Menu Toggle -->
              <div class="mobile-menu-btn d-lg-none">
                <button @click="toggleMobileMenu">
                  <i class="fa fa-bars"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile Menu -->
    <div class="offcanvas-menu" :class="{ active: mobileMenuOpen }">
      <span class="menu-close" @click="toggleMobileMenu"
        ><i class="fas fa-times"></i
      ></span>

      <div id="cssmenu3">
        <ul class="menu">
          <li>
            <router-link to="/" @click.prevent="handleScrollToSection('home')"
              >Home</router-link
            >
          </li>
          <li>
            <a href="#">Courses</a>
            <ul class="submenu">
              <li><router-link to="/courses">Courses</router-link></li>
              <li><router-link to="/programs">Programs</router-link></li>
              <li><router-link to="/trainings">Trainings</router-link></li>
            </ul>
          </li>
          <!-- <li><router-link to="/courses">Courses</router-link></li> -->
          <li><router-link to="/for-mentors">For Mentors</router-link></li>
          <li><router-link to="/contact">Contact</router-link></li>
        </ul>
      </div>
    </div>
    <div
      class="offcanvas-overly"
      :class="{ active: mobileMenuOpen }"
      @click="toggleMobileMenu"
    ></div>
  </header>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useCart } from '@/composables/useCart'; // adjust path as needed
import { useAuth } from "@/composables/useAuth";

export default {
  name: "AppHeader",
  data() {
    return {
      mobileMenuOpen: false, // Controls mobile menu visibility
      redirectText:''
    };
  },
  computed: {
    ...mapGetters(["isLoggedIn"]),
    cartItemsCount() {
      const { cartItemsCount } = useCart();
      return cartItemsCount;
    },
    accountType() {
      const { role } = useAuth()
      return role
    },
    redirectUrl() {
      const { role } = useAuth()
      if (role === 'admin') {
        return '/dashboard/allcourses';
      } else if (role === 'teacher') {
        return '/dashboard/allcourses';
      } else if (role === 'student') {
        return '/dashboard/mycourses';
      } else if (role === 'mentor') {
        return '/dashboard/mentor-dashboard';
      } else return '/dashbaord';
    }

  },
  mounted(){
    this.setRedirectText()
  },
  methods: {
    ...mapActions(["logout"]),
    handleLogout() {
      this.logout();
      this.$router.push("/login");
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    handleScrollToSection(idName) {
      if (this.$route.path !== "/") {
        // Navigate to Home first
        this.$router.push("/").then(() => {
          // Wait for the page to load before scrolling
          this.$nextTick(() => {
            this.scrollToSection(idName);
          });
        });
      } else {
        // If already on Home, just scroll
        this.scrollToSection(idName);
      }
    },
    scrollToSection(sectionId) {
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100); // Small delay to ensure the DOM is updated
    },
    setRedirectText() {
      const { role } = useAuth()
      if (role === 'admin') {
        this.redirectText = 'Dashboard'
      } else if (role === 'teacher') {
        this.redirectText = 'Start Teaching'
      } else if (role === 'student') {
        this.redirectText = 'Continue Learning'
      } else if (role === 'mentor') {
        this.redirectText = 'Start Mentoring'
      } else return '/dashbaord';
    }
  },
};
</script>

<style scoped>

/* Ensure list styles are reset */
#mobile-menu ul,
#mobile-menu li,
#mobile-menu .submenu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Position submenu properly */
#mobile-menu ul li {
  position: relative;
}

#mobile-menu .submenu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 180px;
  background-color: #fff;
  border: 1px solid #eee;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.05);
  z-index: 1000;
}

#mobile-menu li:hover > .submenu {
  display: block;
}

/* Style submenu items */
#mobile-menu .submenu li {
  padding: 10px 20px;
  white-space: nowrap;
}

#mobile-menu .submenu li a {
  color: #333;
  text-decoration: none;
  display: block;
}

/* Optional: hover effect */
#mobile-menu .submenu li a:hover {
  background-color: #f8f8f8;
  color: #007bff;
}



/* Mobile menu toggle button */
@media (max-width: 991px) {
  .mobile-menu-btn {
    display: block;
    position: absolute;
    top: 15px;
    right: 15px;
    font-size: 24px;
    cursor: pointer;
    background: none;
    border: none;
    color: #333;
  }

  .offcanvas-menu {
    position: fixed;
    top: 0;
    right: -100%;
    width: 250px;
    height: 100vh;
    background: #fff;
    box-shadow: -3px 0 5px rgba(0, 0, 0, 0.2);
    transition: right 0.3s ease-in-out;
    padding: 20px;
    z-index: 1000;
  }

  .offcanvas-menu.active {
    right: 0;
  }

  .offcanvas-menu ul li a {
    color: #333;
    font-size: 18px;
    text-decoration: none;
    text-align: left;
  }

  .offcanvas-overly {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }

  .offcanvas-overly.active {
    display: block;
  }

  .menu-close {
    position: absolute;
    top: 10px;
    right: 15px;
    font-size: 20px;
    cursor: pointer;
  }

  .menu ul {
    list-style: none;
    padding: 0;
    margin: 20px 0;
  }

  .menu ul li {
    margin-bottom: 10px;
  }
  .menu ul li a {
    text-decoration: none;
    color: #333;
    font-size: 18px;
  }

  .header-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.cart-icon {
  position: relative;
  color: #2C5C9E;
}

.cart-count {
  position: absolute;
  top: -8px;
  right: -8px;
  background: red;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.second-header-btn {
  display: flex;
  gap: 10px;
  background-color:#2C5C9E
}
}
</style>
